<template>
  <solution-sheet-item :title="title">
    <p class="solution_sheet__item__val" v-if="hasCantilever">
      C1: {{ cantileverSpansLoadValue[0] }}kN
    </p>
    <p
      class="solution_sheet__item__val"
      v-for="(solution_sheet__item, i) in mainSpansLoadValue"
      :key="i"
    >
      V{{ i + 1 }}: {{ mainSpansLoadValue[i] }}kN
    </p>
    <p class="solution_sheet__item__val" v-if="hasCantilever">
      C2: {{ cantileverSpansLoadValue[1] }}kN
    </p>

    <template slot="illustration">
      <calc-illustration which="genericLoad" :is-span-by-span="isSpanBySpan" />
    </template>
  </solution-sheet-item>
</template>

<script>
import { lastOf } from "@/utils";
import { withoutDuplicates } from "@/utils";
import { SolutionSheetItem, CalcIllustration } from "@/components";

export default {
  components: {
    CalcIllustration,
    SolutionSheetItem,
  },
  props: {
    title: {
      required: true,
      type: String,
      default: "Item title not defined",
    },
    loadValue: {
      required: true,
      type: Array,
    },
    hasCantilever: {
      required: true,
      type: Boolean,
    },
  },

  computed: {
    isSpanBySpan() {
      return withoutDuplicates(this.loadValue).length !== 1;
    },

    mainSpansLoadValue() {
      if (this.hasCantilever) {
        return this.loadValue.slice(1, -1);
      } else {
        return [...this.loadValue];
      }
    },

    cantileverSpansLoadValue() {
      if (this.hasCantilever) {
        return [this.loadValue[0], lastOf(this.loadValue)];
      } else {
        return null;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
